import Vue from "vue";
import Buefy from  "buefy";
import PublicContact from "./App.vue";

Vue.use(Buefy, {
    defaultIconPack: 'fas',
})

Vue.use(PublicContact)

if (document.getElementById("publicContactFormApp")){
    new Vue({
        render:h=>h(
            PublicContact,{
                props:{
                    endpoint:document.getElementById("publicContactFormApp")
                        .getAttribute("endpoint"),
                    authUser:document.getElementById("publicContactFormApp")
                        .getAttribute("auth-user")
                }
            }
        )
    }).$mount("#publicContactFormApp")
}